module.exports = __webpack_public_path__ + "img/pda.1f58123c.svg";